export default __webpack_public_path__ + "static/media/prologue.4c675717.wav";